import "./BeneficaryDetails.css";
import { Grid } from "@mui/material";

import GliGrid from "../gliGrid/GliGrid";
import { theme } from "../../../../../../../utils/api/admin/employeePageDesign/theme";
import { BeneficiaryProps, CommonBeneficiaryProps } from "../../../../../../../types/gliForm.types";

// interface CommonBeneficiaryProps {
// 	id: number;
// 	name: string;
// 	date_of_birth: string;
// 	relationship: string;
// 	SSN: string;
// 	address: string;
// 	percentage: string;
// 	type: string;
// }

// interface BeneficiaryProps {
// 	isPrintable: boolean;
// 	beneficiary: CommonBeneficiaryProps[];
// 	handleAddBeneficiary: (beneficiaries: CommonBeneficiaryProps[]) => Promise<void>;
// }

// eslint-disable-next-line react/prop-types
const BeneficaryDetails = ({ isPrintable, beneficiary, handleAddBeneficiary }: BeneficiaryProps) => {
	// console.log("beneficiary==>", beneficiary);
	// console.log("Primary", isPrintable);

	// Function to add a new beneficiary (Max 5)
	const addNewBeneficiary = () => {
		if (beneficiary.length < 5) {
			const newBeneficiary = {
				id: beneficiary.length + 1,
				name: "",
				date_of_birth: "",
				relationship: "",
				SSN: "",
				address: "",
				percentage: "",
				type: ""
			};
			handleAddBeneficiary([...beneficiary, newBeneficiary]);
		}
	};

	// Function to remove a specific beneficiary by ID
	const removeBeneficiary = (id: number) => {
		const updatedBeneficiaries = beneficiary.filter((ben: any) => ben.id !== id);
		handleAddBeneficiary(updatedBeneficiaries);
	};

	return (
		<>
			{/* <div className={isPrintable ? "gli-beneficiary-header-print" : "gli-beneficiary-header"}>
				BENEFICIARY(IES)
			</div> */}
			<div className="gli-beneficary-container">
				<Grid container spacing={1}>
					<Grid item xs={3} sm={3} md={3} lg={3} xl={3} className="gli-grid-header">
						<div className="gli-header-label">Beneficiary’s Name and Address</div>
					</Grid>
					<Grid item xs={2} sm={2} md={2} lg={2} xl={2} className="gli-grid-header2">
						<div className="gli-header-label1">
							Social Security <br></br>Number
						</div>
					</Grid>
					<Grid item xs={2} sm={2} md={2} lg={2} xl={2} className="gli-grid-header3">
						<div className="gli-header-label1">
							Relationship<br></br> To You
						</div>
					</Grid>
					<Grid item xs={2} sm={2} md={2} lg={2} xl={2} className="gli-grid-header4">
						<div className="gli-header-label1">Date of Birth</div>
					</Grid>
					<Grid item xs={1} sm={1} md={1} lg={1} xl={1} className="gli-grid-header5">
						<div className="gli-header-label1">
							<p>
								Percentage:<br></br>Must equal 100%
							</p>
						</div>
					</Grid>
					<Grid item xs={2} sm={2} md={2} lg={2} xl={2} className="gli-grid-header6">
						<div className="gli-header-label1">Beneficiary</div>
					</Grid>
				</Grid>
				{/* <GliGrid
					isPrintable={isPrintable}
					beneficiary={beneficiary}
					handleAddBeneficiary={handleAddBeneficiary}
					id={1}
					index={0}
				/>
				<GliGrid
					isPrintable={isPrintable}
					beneficiary={beneficiary}
					handleAddBeneficiary={handleAddBeneficiary}
					id={2}
					index={1}
				/>
				<GliGrid
					isPrintable={isPrintable}
					beneficiary={beneficiary}
					handleAddBeneficiary={handleAddBeneficiary}
					id={3}
					index={2}
				/> */}
				{/* {beneficiary.map((ben: any, index: any) => (
					<GliGrid
						key={ben.id || index}
						isPrintable={isPrintable}
						beneficiary={beneficiary}
						handleAddBeneficiary={handleAddBeneficiary}
						id={ben.id}
						index={index}
					/>
				))} */}
				{/* Rendering beneficiaries */}
				{beneficiary.map((ben: any, index: number) => (
					<div key={ben.id} className="beneficiary-form">
						{index > 0 && (
							<button className="close-button" onClick={() => removeBeneficiary(ben.id)}>
								X
							</button>
						)}
						<GliGrid
							isPrintable={isPrintable}
							beneficiary={beneficiary}
							handleAddBeneficiary={handleAddBeneficiary}
							id={ben.id}
							index={index}
						/>
					</div>
				))}

				<div className="button-container">
					{beneficiary.length < 5 && (
						<button onClick={addNewBeneficiary} className="add-button">
							Add Beneficiary
						</button>
					)}
				</div>
			</div>
		</>
	);
};

export default BeneficaryDetails;
